export enum ColmatageLit {
    Absence = 1,
    Sables = 2,
    Vases = 3,
    SedimentsFins = 4,
    FormationsBiologiques = 5,
    DebrisVegetauxGrossiers = 6,
    Litieres = 7,
    DepotsIncrustants = 8,
}
